<template>
  <section class="podcasts__hero">
    <div class="image" :style="heroStyles"></div>
    <div class="container">
      <div class="podcasts__hero_logo" v-if="headerImage">
        <img :src="headerImage.url" :alt="headerImage.alt">
      </div>
      <div class="podcasts__hero_sponsors" v-if="sponsors.length > 0">
        <a v-for="(sponsor, index) in sponsors" :key="index" :href="sponsor.url" target="_blank" rel="nofollow">
          <img :src="sponsor.image.url" :alt="sponsor.image.alt">
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: () => ({
    backgroundImage: null,
    headerImage: null,
    sponsors: []
  }),
  computed: {
    heroStyles() {
      const styles = {};

      if (this.backgroundImage) {
        styles['backgroundImage'] = `url('${this.backgroundImage}')`;
      }

      return styles;
    }
  },
  mounted() {
    if(this.$page?.fields?.background_image) {
      this.backgroundImage = this.$page.fields.background_image.url
    }

    if(this.$page?.fields?.header_image) {
      this.headerImage = this.$page?.fields?.header_image
    }

    if(this.$page?.fields?.sponsors?.length) {
      this.sponsors = this.$page.fields.sponsors.map(sponsor => ({
        image: {
          url: sponsor.image.url,
          alt: sponsor.image.alt
        },
        url: sponsor.url || 'javascript:;'
      }))
    }
  }
}
</script>
